import { render, staticRenderFns } from "./CustomerOffersDialog.vue?vue&type=template&id=ecd1c77e&scoped=true"
import script from "./CustomerOffersDialog.vue?vue&type=script&lang=js"
export * from "./CustomerOffersDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerOffersDialog.vue?vue&type=style&index=0&id=ecd1c77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd1c77e",
  null
  
)

export default component.exports